import { Alert } from '@chakra-ui/react';
import PropTypes from 'prop-types';

const VAlert = ({ title, description, icon, ...props }) => (
  <Alert.Root {...props}>
    <Alert.Indicator>{icon}</Alert.Indicator>
    <Alert.Content>
      {title && <Alert.Title>{title}</Alert.Title>}
      {description && <Alert.Description>{description}</Alert.Description>}
    </Alert.Content>
  </Alert.Root>
);

VAlert.propTypes = {
  title: PropTypes.node,
  description: PropTypes.node,
  icon: PropTypes.node,
  status: PropTypes.oneOf(['info', 'success', 'warning', 'error']),
  variant: PropTypes.oneOf(['subtle', 'solid', 'surface']),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  colorPalette: PropTypes.string,
};

export default VAlert;
